import { WebLayout } from "@/components/shared/layout/homepage";
import { Booking } from "@/containers/booking";
import type { AirconServiceName, ServiceName } from "@/types/service";
import { useParams } from "@/components/hooks/use-params";
import { useEffect } from "react";
import { useBookingState } from "@/store/booking/useBookingState";
import { useRoute } from "@/components/shared/router";
import {
  AirconServiceNames,
  airconServiceTypeOptions,
} from "@/constants/booking";
import { getQueryParam } from "@/lib/utils";
import { SERVICE_PARAM } from "@/constants";

export function BookingPage() {
  const { name } = useParams<{ name: ServiceName }>();
  const {
    setBookingState,
    data: { packageDetailsFilter },
  } = useBookingState();
  const { push } = useRoute();

  const onClickAirconService = (name: AirconServiceName) => {
    const airconService = airconServiceTypeOptions.find(
      (item) => item.name === name,
    );
    if (!airconService) {
      throw new Error("package not found");
    }
    setBookingState({
      packageDetailsFilter: {
        ...packageDetailsFilter,
        serviceTypes: [airconService.value],
        repeatEvery: [airconService.repeatEvery],
        repeatEveryTimes: airconService.duration,
      },
    });
    push("/booking/aircon-service");
  };

  if (!name) {
    return <div>404</div>;
  }

  useEffect(() => {
    const service = getQueryParam(SERVICE_PARAM);

    if (
      name === "aircon-service" &&
      service &&
      AirconServiceNames.includes(service)
    ) {
      onClickAirconService(service as AirconServiceName);
    }
  }, []);

  return (
    <WebLayout>
      <Booking name={name} />
    </WebLayout>
  );
}
